module.exports = __webpack_public_path__ + "assets/payments-black.cc2514df.svg";